// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB4rPpF3OyvWmSWh8ty-BJbI7ReD-tpd5Q",
  authDomain: "naubite-c9638.firebaseapp.com",
  databaseURL: "https://naubite-c9638-default-rtdb.firebaseio.com",
  projectId: "naubite-c9638",
  storageBucket: "naubite-c9638.appspot.com",
  messagingSenderId: "933505319000",
  appId: "1:933505319000:web:ea0a54706bf44fc6910a2d",
  measurementId: "G-CFQPX3LQT3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getFirestore(app);
const auth = getAuth(app);

// const analytics = getAnalytics(app);

export { auth, database};
